<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Set Annual Payroll for Year '{{inner_Year}}' for '{{inner_Person_Fullname}}'</h5>
      <form [formGroup]="AddNewSalary" (submit)="SubmitAddNewSalary()">


        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Base Salary (Adjustment)</label>
            <input formControlName="Payeh" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Payeh().valid && get_Form_Payeh().touched" class="form-text text-muted MyErrorRedColor">Enter the base salary.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Shift Allowance</label>
            <input formControlName="Shift" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Shift().valid && get_Form_Shift().touched" class="form-text text-muted MyErrorRedColor">Enter the shift allowance.</small>
          </div>
        </div>

        <hr/>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Experience Score</label>
            <input formControlName="Tajrobeh" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Tajrobeh().valid && get_Form_Tajrobeh().touched" class="form-text text-muted MyErrorRedColor">Enter the experience score.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Kpi</label>
            <input formControlName="Kpi" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Kpi().valid && get_Form_Kpi().touched" class="form-text text-muted MyErrorRedColor">Enter the KPI.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Transportation Allowance</label>
            <input formControlName="AyabZohab" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_AyabZohab().valid && get_Form_AyabZohab().touched" class="form-text text-muted MyErrorRedColor">Enter the transportation allowance.</small>
          </div>

        </div>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewSalary.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button (click)="onBack()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>
